import React from 'react';
import { cn } from '~/helpers/utils';

type ToolPanelProps = {
  className?: string;
  children?: React.ReactNode;
};

const ToolPanel: React.FC<ToolPanelProps> = ({ className, children }) => {
  return (
    <div className={cn('bg-white p-6 md:p-8 xl:p-10 rounded-lg shadow-lg', className)}>
      {children}
    </div>
  );
};

export default ToolPanel;